/**
 * Instructions Steps used for Instruction steps for Courses
 */
export enum InstructionsSteps {
  CERTIFICATION_EXAM_STEPS = 'certificate_exam_steps',
  SELF_STUDY_STEPS = 'self-study-steps',
  SELF_STUDY_DETAILS = 'self-study-details',
  REMOTE_ACCESS_SELF_STUDY_STEPS = 'remote_access_self-study-steps',
  REMOTE_ACCESS_SELF_STUDY_DETAILS = 'remote_access_self-study-details',
  INSTRUCTOR_LED_ENROLLED_SESSION_STEPS = 'enrolled_session_steps',
}
